import {Component, OnDestroy, OnInit} from '@angular/core';

import {ProjectService} from '@catcore/services';

import {Project} from '@catcore/types/api-v2';
import {FeatureComponent} from '@catdetails/components/feature/feature.component';
import {ProjectDetailsFeaturesService} from '@catdetails/services';
import {ProjectUnitsService} from '@catmodules/models/project-units/services/project-units.service';
import {ProjectUnit} from '@catmodules/models/project-units/types';
import {ModalService} from '@catmodules/widgets/slide-in-modal/services/modal.service';
import {isNullOrUndefined} from 'util';
import {ModifyUnitComponent} from "@catmodules/models/units/components/modify-unit/modify-unit.component";
import {GenericLinkedResource} from "@catcore/types/base";
import {Subscription} from "rxjs/Subscription";
import {GenericResourceService} from "@catfeatures/services/generic-resource.service";

interface TableItem {
  unitLabel: string;
  unitLocationAddress: string;
  featureLabel: string;
  guiZoneLabel: string;
  unit: any;
}

@Component({
  styleUrls: ['./features.component.scss'],
  templateUrl: './features.component.html',
})
export class FeaturesComponent implements OnInit, OnDestroy {
  datatableSource: TableItem[] = [];
  private units;
  subscription = null;
  private unitSubscription: Subscription;

  private project: Project;

  constructor(private projectService: ProjectService,
              private projectDetailsFeaturesService: ProjectDetailsFeaturesService,
              private modalService: ModalService,
              private genericService: GenericResourceService,
              private projectUnitService: ProjectUnitsService) {
  }

  ngOnInit() {
    this.projectDetailsFeaturesService.setActive();
    this.subscription = this.projectService
      .getCurrentProject()
      .subscribe((currentProject: Project) => {
        const isActiveProject = !isNullOrUndefined(currentProject) && !isNullOrUndefined(currentProject.id);
        if (isActiveProject) {

          this.project = currentProject;

          const subscr = this.projectService.getAllUnits(this.project)
            .finally(() => subscr.unsubscribe())
            .subscribe((units) => {
              this.units = units;
              this.updateTableData(units);
            });

        } else {
          this.project = null;
        }
      });

  }

  ngOnDestroy() {
    this.projectDetailsFeaturesService.setInActive();
    this.subscription.unsubscribe();
  }

  openFeatureDetailDialog(selectedUnit) {
    const modal = this.modalService.open(FeatureComponent);
    const units = this.datatableSource
      .map((item) => item.unit)
      .filter((unit) => unit._links.feature.href === selectedUnit._links.feature.href);

    modal.componentInstance.feature = selectedUnit._embedded.feature;
    modal.componentInstance.featureUnits = units;
  }

  openUnitDetailDialog(selectedUnit) {
    this.openDialog({
        label: selectedUnit.label,
        href: selectedUnit._links.self.href
      }, (unit) => this.unitModalFactory(unit)
    );
  }

  private onUnitUpdate(updatedUnit) {
    let unit = this.units.find((unit) => unit.id === updatedUnit.id);
    if (unit) {
      unit.location_address = updatedUnit.location_address;
      unit.label = updatedUnit.label;
      unit.display_label = updatedUnit.display_label;
      this.updateTableData(this.units);
    }
  }

  private updateTableData(units) {
    this.datatableSource = [];
    units.forEach((unit: ProjectUnit) => {
      const item = {
        unitLabel: this.projectUnitService.getNameForUnit(unit),
        unitLocationAddress: unit.location_address,
        featureLabel: unit._links.feature.label,
        guiZoneLabel: unit._embedded.feature._links.gui_zone.label,
        unit: unit,
      };
      this.datatableSource = [...this.datatableSource, item];
    });
  }


  private unitModalFactory(unit) {
    const compRef = this.modalService.open(ModifyUnitComponent);
    compRef.componentInstance.unit = unit;
    compRef.componentInstance.enableDelete = false;
    compRef.componentInstance.afterUpdate.subscribe((updatedUnit) => {this.onUnitUpdate(updatedUnit)});
    return compRef;
  }

  private openDialog(resource: GenericLinkedResource, componentFactory) {
    let compRef;
    const onFullfill = () => {
      resourceHandler.refresh();
      this.unitSubscription.unsubscribe();
    };

    const onError = () => {
      this.unitSubscription.unsubscribe();
    };

    const resourceHandler = this
      .genericService
      .findServiceForResource(resource.href);

    this.unitSubscription = resourceHandler
      .loadAndGet()
      .subscribe((item) => {
        if (compRef) {
          compRef.close();
          compRef = null;
        }

        if (isNullOrUndefined(item)) {
          compRef = null;
        } else {
          compRef = componentFactory(item);
          compRef.result.then(onFullfill, onError);
        }
      });
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/project-details/components/features/features.component.ts